// Core
import React from 'react';
// Material-ui
import { Collapse, List } from '@material-ui/core';
// Helpers
import { overrideStyles } from '../../helpers/styles';
// Styles
import { useRowCollapserStyles } from './rowListCollapser.style';
/**
 * Row list collapser
 * @param props - Component properties
 */
var RowListCollapser = function (props) {
    var classes = props.classes, openRow = props.openRow, row = props.row;
    /** State open */
    var _a = React.useState(props.openRow), open = _a[0], setOpen = _a[1];
    /** Life cycle */
    React.useEffect(function () {
        setOpen(openRow);
    }, [openRow]);
    /** External classes */
    var externalClasses = classes;
    /** Component classes */
    var innerClasses = overrideStyles(useRowCollapserStyles(), externalClasses);
    return (React.createElement(List, { className: innerClasses.root },
        row,
        React.createElement(Collapse, { className: innerClasses.collapse, in: open, timeout: "auto" }, props.children)));
};
export default React.memo(RowListCollapser);
//# sourceMappingURL=RowListCollapser.js.map